import { createUseStyles } from "react-jss";

const styles = createUseStyles({
  backButtonHeader: {
    padding: 20,
    paddingTop: 10,
  },
  subtitle: {
    marginTop: 10,
  },
  buttonContainer: {
    backgroundColor: "transparent",
    border: "none",
    display: "flex",
    flexDirection: "row",
    textTransform: "uppercase",
    alignItems: "center",
    cursor: "pointer",
  },
  titleGroup: {
    flexDirection: "row",
    justifyContent: "space-around",
    flexWrap: "wrap",
  },
  "@media (max-width: 768px)": {
    modalContainer: {
      width: "100%",
    },
    headerContainer: {
      padding: 20,
    },
    titleGroup: {
      flexDirection: "column",
      alignItems: "center",
    },
  },
  "@media (max-width: 576px)": {
    backButtonHeader: {
      padding: 20,
      paddingTop: 60,
    },
    titleGroup: {
      flexDirection: "column",
      alignItems: "center",
    },
  },
});

export default styles;
